import React, { FC } from 'react';
import { Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { bg } from 'images/blog';

interface HeaderSectionProps {
  title: string;
  text: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    backgroundImage: `none`,
    margin: '0 auto',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center -105% ',
    maxWidth: 1920,
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      backgroundImage: `url(${bg})`,
    },
    padding: theme.spacing(0, 3),
  },
  title: {
    marginTop: theme.spacing(14),
  },
  text: {
    maxWidth: 839,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(14),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(18),
    },
  },
}));

const HeaderSection: FC<HeaderSectionProps> = ({ title, text }) => {
  const classes = useStyles();
  return (
    <Grid className={classes.wrapper} container justifyContent="center">
      <Grid className={classes.title} xs={12} item>
        <Typography align="center" variant="h1">
          {title}
        </Typography>
      </Grid>
      <Grid className={classes.text} xs={12} item>
        <Typography align="center"> {text}</Typography>
      </Grid>
    </Grid>
  );
};

export default HeaderSection;
